export default "__VITE_ASSET__DC1CxvaA__"